import { useEffect, useState, useCallback } from "react"
import { compress, decompress } from 'lz-string'
import { config } from "../../tools/config/totalProcessData"
import MarketTable from "../../components/MarketTable"
import * as calculates from '../../tools/market/total/calculates'


function MarketPage() {
    const [filterBy, setFilterBy] = useState(localStorage.getItem('marketStockFilter') || 'stock_rights_fund')

    const [tableData, setTableData] = useState(() => {
        if (localStorage.getItem(`total_data`)) {
            return JSON.parse(decompress(localStorage.getItem(`total_data`)))
        } else { return [] }
    })

    const handleClick = (e) => {
        e.target.classList.add('bg-primary')
        e.target.classList.remove('bg-secondary-subtle')
        setFilterBy(e.target.dataset.filter)
        localStorage.setItem('marketStockFilter', e.target.dataset.filter)
    }

    const className = 'filter fs-5 bg-secondary-subtle p-2 text-dark bg-opacity-50 rounded cursor-pointer ms-2'

    const fetchDataCallback = useCallback(async function fetchData() {
        const response = await fetch(`${process.env.REACT_APP_MARKET}/market/`)
        const data = await response.json()
        const sortedData = data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
        
        let updatedItems;
        updatedItems = calculates.calculate_ao(sortedData)
        updatedItems = calculates.calculate_percent(sortedData)
        updatedItems = calculates.calculate_equal_weight_percent(sortedData)
        updatedItems = calculates.calculate_alarm(sortedData)

        if (updatedItems && updatedItems.length > 0) {

            setTableData(updatedItems)
            localStorage.setItem(`total_data`, compress(JSON.stringify(updatedItems)))
            localStorage.setItem('total_date', new Date().toJSON().slice(0, 10))
        }
        // updatedItems = calculates.calculate_score(data_list)
        // setRows(updatedItems)
    }, [])

    useEffect(() => {
        if (
            !localStorage.getItem(`total_data`) ||
            !JSON.parse(decompress(localStorage.getItem(`total_data`))) ||
            localStorage.getItem('total_date') !== new Date().toJSON().slice(0, 10)
        ) {
            fetchDataCallback()
        }
    }, [fetchDataCallback, filterBy])
    
    return (
        <div>
            <div className="content flex-row-fluid" id="kt_content" dir="rtl">
                <div className="container-fluid mt-lg-0 mt-5">
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center justfiy-start">
                                <div onClick={handleClick} data-filter='stock_rights'
                                    className={filterBy === 'stock_rights' ? className + ' active' : className}>سهام بورس و
                                    حق تقدم
                                </div>
                                <div onClick={handleClick} data-filter='stock_rights_fund'
                                    className={filterBy === 'stock_rights_fund' ? className + ' active' : className}>سهام
                                    بورس و حق تقدم و صندوق سهامی
                                </div>
                                <div onClick={handleClick} data-filter='fund_fixed'
                                    className={filterBy === 'fund_fixed' ? className + ' active' : className}>صندوق درآمد
                                    ثابت
                                </div>
                                <div onClick={handleClick} data-filter='gold'
                                    className={filterBy === 'gold' ? className + ' active' : className}>
                                        صندوق طلا
                                </div>
                            </div>
                            {/* <div>
                                <a href={realtimeLink()} className='btn btn-primary text-white mb-2 p-3'>سیگنال بازار درلحظه</a>
                            </div> */}
                        </div>
                        <div className="">
                            <div className="h-100 w-100 mw-100" >
                                <MarketTable config={config} filterBy={filterBy} rows={tableData} theme='table-striped' />

                                {/* <MarketTable config={config} filterBy={filterBy} rows={rows} theme='table-striped' /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarketPage